export const PLUGIN_MANAGER = "PLUGIN_MANAGER";
export const STANDALONE_FWUPGRADE = "STANDALONE_FWUPGRADE";